<template>
  <div>
    <div
      class="absolute inset-0 w-full h-56 bg-auto flex content-center justify-center flex-wrap shadow-lg"
      :style="{
        backgroundImage: 'url(' + require('../assets/background-1.jpg') + ')'
      }"
    >
      <div class="text-5xl font-extrabold">{{ post.title }}</div>
      <div class="w-full flex content-center justify-center bottom-0 absolute">
        <div
          class="border-solid border-2 border-black bg-black text-white p-4 rounded-full"
        >2 jan 2020</div>
      </div>
    </div>

    <div class="h-40"></div>

    <div v-html="post.content"></div>

    <br />
    <br />
    <br />
    <br />
    <br />
    <div
      v-for="(item, index) in post.comments"
      :key="index"
      class="bg-gray-300 p-8 flex flex-col justify-between shadow-lg mb-4"
    >{{ item.comment }}</div>
  </div>
</template>

<script>
// @ is an alias to /src
// {{ $route.params }}
//TODO-stefan header image toevoegen aan header component en via vuex laten veranderen

import gql from "graphql-tag";

const GET_BLOG_POST = gql`
  query getPost($postSlug: String!) {
    post(where: { slug: $postSlug }) {
      title
      content
      author {
        name
      }
      categories {
        title
      }
    }
  }
`;

export default {
  name: "Home",
  props: ["imageHeader"],
  mounted: function() {
    this.slug = this.$route.params.slug;
  },
  data: function() {
    return {
      slug: "",
      post: {}
    };
  },
  apollo: {
    post: {
      query: GET_BLOG_POST,
      // Static parameters
      variables() {
        // Use vue reactive properties here
        return {
          postSlug: this.$route.params.slug
        };
      }
    }
  }
};
</script>
